import React, { useState, useEffect, useContext } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Axios from 'axios';
import {
  Alert,
  DataStatus,
  ActionButton,
  BackButton,
  Input,
  DatePicker,
  Approval,
} from 'components';
import { Row, Col, Card, Modal } from 'react-bootstrap';
import { RupiahConvert, DateConvert, ApprovalStatus } from 'utilities';
import { RABApi } from 'api';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { RABContext, RABContextProvider } from './RABContext';
import { TableRAB } from './Section';

const DetailRAB = ({ setNavbarTitle }) => {
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();

  const ContentDetailRAB = () => {
    const {
      dataAnalisaBarangJadi: contextAnalisa,
      setDataAnalisaBarangJadi: setAnalisaContext,
      dataPrelim,
      setDataPrelim,
      setType,
    } = useContext(RABContext);
    const { tab } = location.state;
    const [isPageLoading, setIsPageLoading] = useState(true);
    const [dataRAB, setDataRAB] = useState({});
    const [dataListRAB, setDataListRAB] = useState([]);
    const [dataApproval, setDataApproval] = useState([]);
    const [dataBehavior, setDataBehavior] = useState('');
    const [alertConfig, setAlertConfig] = useState({
      show: false,
      variant: 'primary',
      text: '',
    });
    const [modalConfig, setModalConfig] = useState({
      show: false,
      type: '',
      title: '',
    });

    const getInitialData = () => {
      setIsPageLoading(true);

      //GET SINGLE DETAIL RAB
      Axios.all([RABApi.getSingle({ id_rab: id })])
        .then(
          Axios.spread((data) => {
            const dataAll = data.data.data;
            const dataInfo = dataAll.detail;
            const dataList = dataInfo.detail_barang_jadi ?? [];
            const dataPrelim = dataInfo.detail_prelim ?? [];

            const mapDataListRAB = dataList.map((val) => ({
              id_rab_detail: val.id_rab_detail,
              id_barang_jadi: val.id_barang_jadi,
              kode_item: val.kode_item,
              nama_item: val.nama_item,
              nama_satuan: val.nama_satuan,
              qty: val.qty_rab ? parseFloat(val.qty_rab) : 0,
              harga: val.harga_satuan_rab
                ? parseFloat(val.harga_satuan_rab)
                : 0,
              rounded: val.rounded ? parseFloat(val.rounded) : 0,
              profit: val.harga_satuan_rab
                ? parseFloat(val.harga_satuan_rab)
                : 0,
            }));

            const filterPrelim = dataPrelim.map((val, index) => ({
              id_kelompok: val.id_kelompok,
              id_item: val.id_item_prelim,
              kode_item: val.kode_item_prelim,
              nama_item: val.nama_item_prelim,
              qty_item: val.qty_analisa,
              id_unit: val.id_satuan_prelim,
              nama_unit: val.nama_satuan_prelim,
              harga: parseFloat(val.unit_price ?? 0),
              qty_durasi: parseFloat(val.qty_durasi ?? 0),
              konstanta: parseFloat(val.konstanta ?? 0),
              order: index + 1,
            }));

            setDataRAB(dataInfo);
            setDataApproval(dataAll.approval);
            setDataBehavior(dataAll.behavior);
            setDataListRAB(mapDataListRAB);
            setDataPrelim(filterPrelim);
          })
        )
        .catch(() => {
          setAlertConfig({
            show: true,
            variant: 'danger',
            text: 'Data gagal dimuat!',
          });
        })
        .finally(() => setIsPageLoading(false));
    };

    const checkAlert = () => {
      const locationState = location.state;

      if (locationState) {
        if (locationState.alert) {
          setAlertConfig({
            show: locationState.alert.show,
            text: locationState.alert.text,
            variant: locationState.alert.variant,
          });
        }
      }
    };

    const InfoItem = ({ title, value }) => (
      <tr>
        <td>{title}</td>
        <td className="pl-4 pr-2">:</td>
        <td>{value}</td>
      </tr>
    );

    const InfoSection = () => {
      return (
        <Row>
          <Col>
            <table style={{ fontSize: '14px' }}>
              <tbody>
                <InfoItem
                  title="Tgl. RAE"
                  value={
                    dataRAB?.tgl_rae
                      ? DateConvert(new Date(dataRAB.tgl_rae)).detail
                      : '-'
                  }
                />
                <InfoItem title="No. RAE" value={dataRAB?.no_rae ?? '-'} />
                <InfoItem title="Proyek" value={dataRAB?.nama_proyek ?? '-'} />
              </tbody>
            </table>
          </Col>
          <Col>
            <table style={{ fontSize: '14px' }}>
              <tbody>
                <InfoItem
                  title="Customer"
                  value={dataRAB?.nama_customer ?? '-'}
                />
                <InfoItem title="ATT" value={dataRAB?.att ?? '-'} />
                <InfoItem
                  title="Tgl. Selesai"
                  value={
                    dataRAB?.tgl_selesai
                      ? DateConvert(new Date(dataRAB.tgl_selesai)).detail
                      : '-'
                  }
                />
              </tbody>
            </table>
          </Col>
        </Row>
      );
    };

    const GrandTotalSection = ({ getGrandTotal, getGrandTotalPrelim }) => {
      return (
        <div className="p-2 bg-light text-right border">
          <b className="text-nowrap pr-3" style={{ fontSize: '14px' }}>
            Grand Total :{' '}
            {
              RupiahConvert(
                String(parseInt(getGrandTotal + getGrandTotalPrelim))
              ).detail
            }
          </b>
        </div>
      );
    };

    useEffect(() => {
      setNavbarTitle('Detail Rencana Anggaran Biaya');
      getInitialData();
      checkAlert();
      setType('DETAIL');
      return () => {
        setIsPageLoading(false);
      };
    }, []);

    const mappingHardwood = (data) =>
      data.map((val) => ({
        id_barang_jadi: val.id_barang_jadi,
        urutan_item: val.urutan_item,
        id_deskripsi: val.id_deskripsi,
        is_header: val.is_header,
        qty_raw: val.qty_raw,
        t_raw: val.t_raw,
        w_raw: val.w_raw,
        l_raw: val.l_raw,
        qty_final: val.qty_final,
        t_final: val.t_final,
        w_final: val.w_final,
        l_final: val.l_final,
        unit_price: val.unit_price,
        konstanta: val.konstanta,
        id_jenis_kayu: val.id_jenis_kayu,
        id_finishing_barang_jadi: val.id_finishing_barang_jadi,
        id_tipe_sisi: val.id_tipe_sisi,
        id_part_kayu: val.id_part_kayu,
      }));

    const mappingPlywood = (data) =>
      data.map((val) => ({
        id_barang_jadi: val.id_barang_jadi,
        urutan_item: val.urutan_item,
        id_deskripsi: val.id_deskripsi,
        deskripsi: val.deskripsi,
        is_header: val.is_header,
        qty_final: val.qty_final,
        t_final: val.t_final,
        w_final: val.w_final,
        l_final: val.l_final,
        qty_raw: val.qty_raw,
        t_raw: val.t_raw,
        w_raw: val.w_raw,
        l_raw: val.l_raw,
        unit_price: val.unit_price,
        konstanta: val.konstanta,
        id_item_buaso: val.id_item_buaso,
        id_finishing_barang_jadi: val.id_finishing_barang_jadi,
        id_tipe_sisi: val.id_tipe_sisi,
      }));

    const mappingTP = (value) => {
      const final = [];
      value.map((val) => {
        final.push({
          id_barang_jadi: val.id_barang_jadi,
          id_item_buaso: val.id_item_buaso,
          qty: val.qty,
          unit_price: val.unit_price,
          konstanta: val.konstanta,
        });
      });

      return final;
    };

    const mappingFN = (value) => {
      const final = [];
      value.map((val) => {
        final.push({
          id_barang_jadi: val.id_barang_jadi,
          id_item_buaso: val.id_item_bahan,
          qty: val.qty,
          unit_price: val.unit_price,
          konstanta: val.konstanta,
          id_finishing_barang_jadi: val.id_finishing_barang_jadi,
        });
      });

      return final;
    };

    const mappingPrelim = (data) =>
      data.map((val) => ({
        id_item_buaso: val.id_item,
        qty_analisa: val.qty_item,
        unit_price: val.harga,
        qty_durasi: val.qty_durasi,
        id_satuan_durasi: val.id_unit,
        konstanta: val.konstanta,
      }));

    // INITIAL VALUES FORM TAMBAH DATA TIPE BARANG JADI
    const formInitialValues = {
      id_rae: id,
      tgl_rab: dataRAB.tgl_rab,
      no_rab: dataRAB.no_rab,
      profit: dataRAB.profit,
    };

    // FORMIK VALIDATION SCHEMA TIPE BARANG JADI DENGAN YUP VALIDATION
    const formValidationSchema = Yup.object().shape({
      tgl_rab: Yup.date().required('Tanggal RAB wajib diisi'),
    });

    // KIRIM UPDATE DATA KE SERVER
    const formSubmitHandler = (values, { setSubmitting }) => {
      const detailAnalisa = [];
      contextAnalisa.map((val) =>
        detailAnalisa.push({
          index: val.index,
          analisa_hardwood: mappingHardwood(val.dataHardwood ?? []),
          analisa_plywood: mappingPlywood(val.dataPlywood ?? []),
          analisa_fin_tp_fs: mappingTP(val.dataTPFS ?? []),
          analisa_fin_tp_lc: mappingTP(val.dataTPLC ?? []),
          analisa_fin_tp_mp: mappingTP(val.dataTPMP ?? []),
          analisa_fin_tp_bop: mappingTP(val.dataTPBOP ?? []),
          analisa_fin_fn_bp: mappingFN(val.dataFNBP ?? []),
          analisa_fin_fn_sc: mappingFN(val.dataFNSC ?? []),
          analisa_fin_fn_lc: mappingFN(val.dataFNLC ?? []),
          analisa_alat_bantu_onsite: val.dataAlatBantuOnSite,
          analisa_biaya_overhead_kantor: val.dataAnalisaBOK,
          analisa_labour_cost_onsite: val.dataLabourCostOnSite,
        })
      );

      const listRAB = dataListRAB.map((val, idx) => ({
        id_rab_detail: val.id_rab_detail,
        rounded: val.rounded,
        harga_satuan_rab: val.harga,
        qty_rab: val.qty,
        id_barang_jadi: val.id_barang_jadi,
        analisa_barang_jadi: detailAnalisa.find((val) => val.index === idx)
          ? detailAnalisa.find((val) => val.index === idx)
          : {},
      }));

      const finalValues = {
        id_rab: id,
        id_rae: dataRAB.id_rae,
        tgl_rab: values.tgl_rab,
        no_rab: values.no_rab,
        profit: values.profit,
        prelim: 0,
        detail_barang_jadi: listRAB,
        detail_prelim: mappingPrelim(dataPrelim),
      };

      RABApi.save(finalValues)
        .then(() =>
          history.push('/transaksi/rencana-anggaran-biaya', {
            alert: {
              show: true,
              variant: 'primary',
              text: 'Data berhasil ubah!',
            },
          })
        )
        .catch(() => {
          setAlertConfig({
            show: true,
            variant: 'danger',
            text: 'Data gagal ditambah!',
          });
        })
        .finally(() => setSubmitting(false));
    };

    const ModalSection = ({ values, isSubmitting, handleSubmit }) => {
      const ModalContent = () => (
        <>
          <Modal.Body className="text-center">
            <p>
              <h6>
                <b>{modalConfig.title} dengan catatan :</b>
              </h6>
              <span>{values.catatan}</span>
            </p>
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            <ActionButton
              variant="outline-secondary"
              text="Batal"
              className="px-4"
              onClick={() =>
                setModalConfig({
                  ...modalConfig,
                  show: false,
                })
              }
            />
            <ActionButton
              text={ApprovalStatus(modalConfig.type, dataBehavior).text}
              variant={ApprovalStatus(modalConfig.type, dataBehavior).variant}
              className="m-1 px-3 text-white"
              onClick={handleSubmit}
              loading={isSubmitting}
            />
          </Modal.Footer>
        </>
      );

      return (
        <Modal
          show={modalConfig.show}
          onHide={() =>
            setModalConfig({
              ...modalConfig,
              show: false,
            })
          }
        >
          <Modal.Header closeButton className="py-2 d-flex align-items-center">
            <Modal.Title>
              <small>{modalConfig.title}</small>
            </Modal.Title>
          </Modal.Header>
          <ModalContent />
        </Modal>
      );
    };

    return (
      <>
        <Card>
          <Card.Header className="d-flex justify-content-between align-items-center">
            <b>Detail Data RAB</b>
            <BackButton onClick={() => history.goBack()} />
          </Card.Header>
          <Card.Body>
            <Alert
              showCloseButton
              show={alertConfig.show}
              variant={alertConfig.variant}
              text={alertConfig.text}
              onClose={() =>
                setAlertConfig({
                  ...alertConfig,
                  show: false,
                })
              }
            />
            {isPageLoading ? (
              <DataStatus loading={true} text="Memuat data . . ." />
            ) : (
              <>
                <InfoSection />
                <hr />
              </>
            )}

            <Formik
              enableReinitialize={true}
              initialValues={formInitialValues}
              validationSchema={formValidationSchema}
              onSubmit={formSubmitHandler}
            >
              {({
                values,
                errors,
                touched,
                isSubmitting,
                handleChange,
                handleSubmit,
                setFieldValue,
                setValues,
              }) => {
                const getNewNomor = (tgl) => {
                  RABApi.getNomorRAB({ tanggal: tgl })
                    .then((res) => {
                      const nomor = res?.data?.data ?? '';

                      setValues({
                        ...values,
                        no_rab: nomor,
                        tgl_rab: tgl,
                      });
                    })
                    .catch((err) => {
                      window.alert('Nomor gagal dimuat');
                      setValues({
                        ...values,
                        no_rab: '',
                        tgl_rab: '',
                      });
                    })
                    .finally(() => setIsPageLoading(false));
                };

                const getTotal = (index) => {
                  const price = dataListRAB[index].rounded
                    ? dataListRAB[index].rounded
                    : 0;
                  const qty = dataListRAB[index].qty
                    ? dataListRAB[index].qty
                    : 0;

                  return parseFloat(price * qty);
                };

                const getAfterProfit = (index) => {
                  const newProfit = values.profit
                    ? parseFloat(values.profit)
                    : 0;
                  const newHarga = dataListRAB[index].harga
                    ? parseFloat(dataListRAB[index].harga)
                    : 0;
                  const afterProfit = (newProfit / 100 + 1) * newHarga;

                  return parseInt(afterProfit);
                };

                const getGrandtotal = dataListRAB.reduce(
                  (prev, current, index) => {
                    return prev + getTotal(index);
                  },
                  0
                );

                const getGrandTotalPrelim = dataPrelim.reduce(
                  (prev, current) => {
                    const newQtyItem = current.qty_item
                      ? parseFloat(current.qty_item)
                      : 0;
                    const newHarga = current.harga
                      ? parseFloat(current.harga)
                      : 0;
                    const newQtyDurasi = current.qty_durasi
                      ? parseFloat(current.qty_durasi)
                      : 0;
                    const newKonts = current.konstanta
                      ? parseFloat(current.konstanta)
                      : 0;
                    const subTotal = newQtyItem * newHarga;
                    const total = subTotal;

                    return prev + total;
                  },
                  0
                );

                const onProfitChange = (profit) => {
                  const newProfit = profit ? profit : 0;

                  const newList = dataListRAB.map((val) => {
                    const afterProfit = (newProfit / 100 + 1) * val.harga;

                    return {
                      ...val,
                      profit: parseInt(afterProfit),
                      rounded: parseInt(afterProfit),
                    };
                  });

                  setFieldValue('profit', profit);
                  setDataListRAB(newList);
                };

                const onInputRoundedChange = ({ value, index }) => {
                  const newList = dataListRAB.map((val, idx) =>
                    idx === index ? { ...val, rounded: value } : val
                  );

                  setDataListRAB(newList);
                };

                return (
                  <form onSubmit={handleSubmit}>
                    {!isPageLoading && (
                      <div className="row my-3">
                        <div className="col-md-6">
                          <DatePicker
                            label="Tgl. RAB"
                            name="tgl_rab"
                            dateFormat="dd/MM/yyyy"
                            selected={
                              values.tgl_rab ? new Date(values.tgl_rab) : ''
                            }
                            error={errors.tgl_rab && touched.tgl_rab && true}
                            errorText={errors.tgl_rab}
                            disabled
                          />
                        </div>
                        <div className="col-md-6">
                          <Input
                            label="No. RAB"
                            type="text"
                            name="no_rab"
                            value={dataRAB.no_rab}
                            readOnly={true}
                          />
                        </div>
                      </div>
                    )}

                    {!isPageLoading && (
                      <TableRAB
                        profit={values.profit}
                        dataListRAB={dataListRAB}
                        setDataListRAB={setDataListRAB}
                        getTotal={getTotal}
                        getAfterProfit={getAfterProfit}
                        getGrandTotalPrelim={getGrandTotalPrelim}
                        onProfitChange={onProfitChange}
                        onInputRoundedChange={onInputRoundedChange}
                      />
                    )}

                    {!isPageLoading && (
                      <GrandTotalSection
                        getGrandTotal={getGrandtotal}
                        getGrandTotalPrelim={getGrandTotalPrelim}
                      />
                    )}
                  </form>
                );
              }}
            </Formik>
          </Card.Body>
        </Card>

        {!isPageLoading && (
          <Formik
            initialValues={{ catatan: '' }}
            validationSchema={Yup.object().shape({
              catatan: Yup.string().required('Masukan catatan'),
            })}
            onSubmit={(values) => {
              const finalValues = {
                ...values,
                no_transaksi: dataRAB.no_rab,
                status_approval: modalConfig.type,
                tgl_approval: DateConvert(new Date()).default,
                approval_baseline: dataRAB.baseline,
              };

              RABApi.approve(finalValues)
                .then((res) => {
                  history.push('/human-resource/approval/rab', {
                    alert: {
                      show: true,
                      variant: 'primary',
                      text: `${
                        modalConfig.type == 'APP'
                          ? 'Approve'
                          : modalConfig.type === 'VER'
                          ? 'Verify'
                          : modalConfig.type == 'REV'
                          ? 'Revise'
                          : 'Reject'
                      } data berhasil!`,
                    },
                  });
                  const logValues = {
                    no_transaksi: dataRAB.no_rab,
                    nama_transaksi: 'Peluang',
                    baseline: dataRAB.baseline,
                    status_approval: modalConfig.type,
                    no_transaksi_ref: dataRAB.no_rae,
                    baseline_ref: dataRAB.baseline,
                    keterangan_transaksi:
                      modalConfig.type === 'APP'
                        ? 'Approve Rencana Anggaran Biaya'
                        : modalConfig.type === 'VER'
                        ? 'Verifikasi Rencana Anggaran Biaya'
                        : 'Reject Rencana Anggaran Biaya',
                  };
                  RABApi.saveLogProgress(logValues);
                })
                .catch((err) => {
                  setAlertConfig({
                    variant: 'danger',
                    text: `Ubah data gagal! (${err.response.data.message})`,
                  });
                })
                .finally(() => setModalConfig({ show: false }));
            }}
          >
            {({
              values,
              isSubmitting,
              handleChange,
              handleSubmit,
              errors,
              touched,
              validateForm,
              setTouched,
              dirty,
            }) => (
              <>
                {!isPageLoading && (
                  <Approval
                    values={values}
                    handleChange={handleChange}
                    dirty={dirty}
                    validateForm={validateForm}
                    errors={errors}
                    touched={touched}
                    approveStatus={dataBehavior}
                    data={dataApproval}
                    tab={tab}
                    setModalConfig={setModalConfig}
                    title="Rencana Anggaran Biaya"
                  />
                )}
                <ModalSection
                  values={values}
                  isSubmitting={isSubmitting}
                  handleChange={handleChange}
                  handleSubmit={handleSubmit}
                />
              </>
            )}
          </Formik>
        )}
      </>
    );
  };

  return (
    <RABContextProvider>
      <ContentDetailRAB />
    </RABContextProvider>
  );
};

export default DetailRAB;
